import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { ARCADE_ACCENT } from "../../utils/triviaArcade";

const BEAT_INTERVAL_MS = 2200;

const DEFAULT_BEATS = [
  "Pulling career numbers…",
  "Matching legends…",
  "Shuffling the lineup…",
];

const TriviaStartingScreen = ({
  title,
  subtitle,
  beats = DEFAULT_BEATS,
  reducedMotion = false,
}) => {
  const [beatIndex, setBeatIndex] = useState(0);

  useEffect(() => {
    if (reducedMotion || !beats.length) return undefined;
    const id = setInterval(() => {
      setBeatIndex((index) => (index + 1) % beats.length);
    }, BEAT_INTERVAL_MS);
    return () => clearInterval(id);
  }, [beats, reducedMotion]);

  const beat = beats.length ? beats[beatIndex] : null;

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal,
        bgcolor: "background.default",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        textAlign: "center",
      }}
    >
      <CircularProgress
        size={56}
        thickness={4}
        sx={{ color: ARCADE_ACCENT, mb: 3 }}
      />
      <Typography variant="h4" fontWeight={800} sx={{ mb: 1 }}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: 420 }}>
          {subtitle}
        </Typography>
      ) : null}
      {beat ? (
        <Typography variant="body2" color="text.secondary">
          {beat}
        </Typography>
      ) : null}
    </Box>
  );
};

export default TriviaStartingScreen;
